module.exports = __webpack_public_path__ + "img/icon_lottery_no.2f33e9c4.png";